// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patients_container {
  display: flex;
  flex-direction: column;
}

.main_content_container {
  padding: 20px 32px;
  position: relative;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientsPage/Patientspage.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AACA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AAEJ","sourcesContent":[".patients_container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.main_content_container {\r\n    padding: 20px 32px;\r\n    position: relative;\r\n    flex: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
